const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerpoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECEFF1"
    },
    d: "M496,80.011H272c-8.832,0-16,7.168-16,16v320c0,8.832,7.168,16,16,16h224c8.832,0,16-7.168,16-16 v-320C512,87.179,504.832,80.011,496,80.011z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F57C00"
    },
    d: "M432,368.011H272c-8.832,0-16-7.168-16-16s7.168-16,16-16h160c8.832,0,16,7.168,16,16 S440.832,368.011,432,368.011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F57C00"
    },
    d: "M352,144.011c-44.192,0-80,35.808-80,80s35.808,80,80,80s80-35.808,80-80h-80V144.011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F57C00"
    },
    d: "M384,112.011v80h80C464,147.819,428.192,112.011,384,112.011z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF6C00"
    },
    d: "M282.208,19.691c-3.648-3.04-8.544-4.352-13.152-3.392l-256,48C5.472,65.707,0,72.299,0,80.011v352 c0,7.68,5.472,14.304,13.056,15.712l256,48c0.96,0.192,1.952,0.288,2.944,0.288c3.712,0,7.328-1.28,10.208-3.68 c3.68-3.04,5.792-7.584,5.792-12.32v-448C288,27.243,285.888,22.731,282.208,19.691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M112,368.011c-8.832,0-16-7.168-16-16v-160c0-8.832,7.168-16,16-16h48c35.296,0,64,28.704,64,64 s-28.704,64-64,64h-32v48C128,360.843,120.832,368.011,112,368.011z M128,272.011h32c17.632,0,32-14.368,32-32s-14.368-32-32-32h-32 V272.011z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpoint);
export default __webpack_public_path__ + "static/media/powerpoint.6bd22f40a1fd97f950ff9bd426226b51.svg";
export { ForwardRef as ReactComponent };